module.exports = __webpack_public_path__ + "06_bob_beige.4010cc14.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_bob_beige.png
// module id = pzD7
// module chunks = 0